import React from "react";

export function SectionHeading({ theme, kicker, title, sub, align = "left" }) {
  const isSynth = theme === "synthwave";
  return (
    <div
      className={`mb-14 ${align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-3xl"}`}
    >
      {kicker && (
        <p
          className={`text-xs uppercase tracking-[0.35em] mb-4 ${
            isSynth ? "text-cyan-300" : "font-stamp text-[#c44900]"
          }`}
        >
          {kicker}
        </p>
      )}
      <h2
        className={`font-display uppercase ${
          isSynth
            ? "text-4xl md:text-6xl text-cyan-300 tracking-wider"
            : "text-5xl md:text-7xl text-[#f4ebd8] tracking-tight"
        }`}
      >
        {title}
      </h2>
      {sub && (
        <p
          className={`mt-5 text-base md:text-lg max-w-2xl ${
            isSynth ? "text-gray-300" : "text-[#a89f91]"
          }`}
        >
          {sub}
        </p>
      )}
    </div>
  );
}

export function Divider({ theme }) {
  const isSynth = theme === "synthwave";
  return (
    <div
      className={isSynth ? "laser-divider my-2" : "torn-divider my-2"}
      aria-hidden
    />
  );
}
